module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Coming Soon!","description":"Create worldwide livestreams for your community with just a click."},"es":{"title":"¡Próximamente!","description":"Crea streams en vivo y globales para tu comunidad con sólo un click."}}')
  delete Component.options._Ctor
}
